import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useState } from 'react';
import DataTable from 'components/DataTable';
import { DATE_FORMATS, formatDate, showError } from 'utils';
import moment from 'moment';
import styles from '../refund-report/index.module.scss';
import ExportCSVButton from 'components/ExportCSVButton';
import { fetchDiscountRedemptionReport } from 'services';
import Currency from 'components/Currency/Currency';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Filters from './filters';
import CustomLink from 'components/TableLink';

const columns = [
  {
    name: 'User Name',
    selector: 'user.full_name',
    // eslint-disable-next-line react/display-name
    cell: (row)=>
      <CustomLink
        text={_.get(row, 'user.objectId')}
        linkTo={`/users/${_.get(row, 'user.objectId')}`}
      />,
  },
  {
    name: 'Order ID',
    selector: 'order.objectId',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink 
        text={_.get(row, 'order.objectId')}
        linkTo={`/orders/${_.get(row,'order.objectId')}`}
      />,
  },
  {
    name: 'Discount Code',
    selector: 'discount.code',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink 
        text={_.get(row, 'discount.code')}
        linkTo={`/discount-redemption-report`}
      />,
  },
  {
    name: 'Order Total ($)',
    selector: 'order.total',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.order.total/100} default={'-'} />),
  },
  {
    name: 'Order Subtotals ($)',
    selector: 'order.subtotals',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.order.subtotals} default={'-'} />),
  },
  {
    name: 'Discount Amount ($)',
    selector: 'order.discountAmount',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.order.discountAmount} default={'-'} />),
  },
  {
    name: 'Created At',
    selector: 'createdAt',
    sortable: true,
    format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  },
];

const columnsForCSV = [
  {
    label: 'User Name',
    value: 'user.full_name',
  },
  {
    label: 'Order Id',
    value: 'order.objectId',
  },
  {
    label: 'Discount Code',
    value: 'discount.code',
  },
  {
    label: 'Order Total',
    value: 'order.total',
  },
  {
    label: 'Order Subtotals',
    value: 'order.subtotals',
  },
  {
    label: 'Discount Amount',
    value: 'order.discountAmount',
  },
  {
    label: 'Created At',
    value: 'createdAt',
  },
];

const DiscountRedemptionReport = props => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [filters, setFilters] = useState<Record<string, string>>(
    { 
      discountCode: '',
      user: '', 
      startDate: moment().subtract(3, 'month').toISOString(), 
      endDate: moment().toISOString(), 
    });
  const [loading, setLoading] = useState<boolean>(false);

  const fetchDiscountRedemptionFn = async (filter) => {
    setLoading(true);
    try {
      const response = await fetchDiscountRedemptionReport(filter);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterSubmit = (filters)=>{
    setFilters(filters);
    fetchDiscountRedemptionFn({ startDate: filters.startDate, endDate:filters.endDate });
  };

  const getTableData = () =>(
    data.filter(obj =>(
      _.get(obj.discount, 'code', '').toLowerCase().includes(filters.discountCode.toLowerCase()) && (
        _.get(obj.user,'full_name','').toLowerCase().includes(filters.user.toLowerCase()) ||
        _.get(obj.user,'email','').toLowerCase().includes(filters.user.toLowerCase())
      )
    ))
  );

  useEffect(()=>{
    fetchDiscountRedemptionFn(filters);
  },[]);

  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Discount Redemption Report</div>
        <ExportCSVButton
          fileName={'Discount_Redemption_Report'}
          data={data}
          columnsForCSV={columnsForCSV}
        />
      </div>
      <Filters onSubmit={handleFilterSubmit}/>
      <DataTable
        noHeader
        data={getTableData()}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default DiscountRedemptionReport;